import React, { useRef, useEffect, useState, useCallback } from 'react';

const SignaturePad = ({ onChange }) => {
    const canvasRef = useRef(null);
    const [isDrawing, setIsDrawing] = useState(false);
    const [isEmpty, setIsEmpty] = useState(true);
    const lastPos = useRef(null);
    const dprRef = useRef(1);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const dpr = window.devicePixelRatio || 1;
        dprRef.current = dpr;
        const rect = canvas.getBoundingClientRect();
        canvas.width = rect.width * dpr;
        canvas.height = rect.height * dpr;
        const ctx = canvas.getContext('2d');
        ctx.scale(dpr, dpr);
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, rect.width, rect.height);
    }, []);

    const getPos = (e) => {
        const canvas = canvasRef.current;
        const rect = canvas.getBoundingClientRect();
        const src = e.touches ? e.touches[0] : e;
        return {
            x: src.clientX - rect.left,
            y: src.clientY - rect.top,
        };
    };

    const startDrawing = useCallback((e) => {
        e.preventDefault();
        setIsDrawing(true);
        lastPos.current = getPos(e);
    }, []);

    const draw = useCallback((e) => {
        e.preventDefault();
        if (!isDrawing) return;
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const pos = getPos(e);

        ctx.beginPath();
        ctx.moveTo(lastPos.current.x, lastPos.current.y);
        ctx.lineTo(pos.x, pos.y);
        ctx.strokeStyle = '#1e293b';
        ctx.lineWidth = 2.5;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.stroke();

        lastPos.current = pos;
        setIsEmpty(false);
    }, [isDrawing]);

    const stopDrawing = useCallback(() => {
        if (!isDrawing) return;
        setIsDrawing(false);
        lastPos.current = null;
        // Do NOT call onChange here — user may still be mid-signature
    }, [isDrawing]);

    const confirm = useCallback(() => {
        const canvas = canvasRef.current;
        onChange(canvas.toDataURL('image/png'));
    }, [onChange]);

    const clear = useCallback(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const rect = canvas.getBoundingClientRect();
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, rect.width, rect.height);
        setIsEmpty(true);
        onChange('');
    }, [onChange]);

    return (
        <div className="signature-pad">
            <canvas
                ref={canvasRef}
                className={`signature-canvas${isEmpty ? ' signature-canvas--empty' : ''}`}
                onMouseDown={startDrawing}
                onMouseMove={draw}
                onMouseUp={stopDrawing}
                onMouseLeave={stopDrawing}
                onTouchStart={startDrawing}
                onTouchMove={draw}
                onTouchEnd={stopDrawing}
            />
            <div className="signature-pad-footer">
                <span className="signature-pad-hint">
                    {isEmpty ? '✍️ Firme aquí con el dedo' : isDrawing ? '✏️ Firmando…' : '☝️ Puede levantar el dedo y continuar'}
                </span>
                <div className="signature-pad-actions">
                    {!isEmpty && (
                        <>
                            <button type="button" className="signature-clear-btn" onClick={clear}>
                                Limpiar
                            </button>
                            <button type="button" className="signature-confirm-btn" onClick={confirm}>
                                Listo ✓
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SignaturePad;
